import * as React from "react";

import { EmailEditorOpenedFrom, EmailEntryPoint } from "@simplyk/common";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";

export const useEmailPreview = ({
  emailContent,
}: {
  emailContent?: { id: string; entryPoint?: EmailEntryPoint | null; openedFrom?: EmailEditorOpenedFrom | null };
}) => {
  const [previewOpened, setPreviewOpened] = React.useState(false);
  const { logAmplitudeEvent } = useAmplitude();

  const openPreview = React.useCallback(() => {
    logAmplitudeEvent(AmplitudeEvents.EmailPreviewOpened, {
      openFrom: emailContent?.entryPoint ?? emailContent?.openedFrom,
    });
    setPreviewOpened(true);
  }, [emailContent?.entryPoint, emailContent?.openedFrom, logAmplitudeEvent]);

  const closePreview = React.useCallback(() => setPreviewOpened(false), []);

  return { previewOpened, openPreview, closePreview };
};
